

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_107_0_shadows";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_107_0_shadows__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"s1":"rgba(22, 45, 61, 0.12)","s2":"rgba(22, 45, 61, 0.48)","s3":"rgba(22, 45, 61, 0.06)","s4":"rgba(22, 45, 61, 0.18)","s5":"rgba(22, 45, 61, 0.24)","s6":"rgba(22, 45, 61, 0.3)","s7":"rgba(22, 45, 61, 0.36)","shadow10":"var(--wsr-shadow10, 0 2px 1px 0 rgba(22, 45, 61, 0.48), 0 0 3px 0 rgba(22, 45, 61, 0.12))","shadow20":"var(--wsr-shadow20, 0 2px 4px 0 rgba(22, 45, 61, 0.12), 0 0 6px 0 rgba(22, 45, 61, 0.12))","shadow30":"var(--wsr-shadow30, 0 6px 6px 0 rgba(22, 45, 61, 0.06), 0 0 18px 0 rgba(22, 45, 61, 0.12))","shadow30InnerTop":"var(--wsr-shadow30, inset 0 22px 18px -18px rgba(22, 45, 61, 0.12), inset 0 8px 6px -6px rgba(22, 45, 61, 0.06))","shadow30InnerBottom":"var(--wsr-shadow30, inset 0 -22px 18px -18px rgba(22, 45, 61, 0.12), inset 0 -8px 6px -6px rgba(22, 45, 61, 0.06))","shadow40":"var(--wsr-shadow40, 0 8px 8px 0 rgba(22, 45, 61, 0.12), 0 3px 24px 0 rgba(22, 45, 61, 0.18))"}; 
export var vars = {"wsr-shadow10":"--wsr-shadow10","wsr-shadow20":"--wsr-shadow20","wsr-shadow30":"--wsr-shadow30","wsr-shadow40":"--wsr-shadow40"}; 




